// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2H6ZD","head":"Table_head__1UCUW","col":"Table_col__xRRbL"};